import { styled } from "styled-components";

export const SearchIconContainer = styled.div`
  background-color: #383838;
  border-radius: 30px;
  width: 49px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  margin-right: 12px;
  cursor: pointer;
`;
